import type { LanguageCodeToName } from 'pages/localization/types';

export const AVAILABLE_LANGUAGES_FULL = [
    { code: 'en', name: 'English' },
    { code: 'de', name: 'German' },
    { code: 'fr', name: 'French' },
    { code: 'it', name: 'Italian' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'es', name: 'Spanish' },
    { code: 'ja', name: 'Japanese' },
    { code: 'ko', name: 'Korean' },
    { code: 'tr', name: 'Turkish' },
    { code: 'pl', name: 'Polish' },
    { code: 'no', name: 'Norwegian' },
    { code: 'cs', name: 'Czech' },
    { code: 'da', name: 'Danish' },
    { code: 'ro', name: 'Romanian' },
    { code: 'hu', name: 'Hungarian' },
    { code: 'fi', name: 'Finnish' },
    { code: 'sv', name: 'Swedish' },
    { code: 'el', name: 'Greek' },
    { code: 'sk', name: 'Slovak' },
    { code: 'bg', name: 'Bulgarian' },
    { code: 'hr', name: 'Croatian' },
    { code: 'sl', name: 'Slovenian' },
    { code: 'lt', name: 'Lithuanian' },
    { code: 'et', name: 'Estonian' },
    { code: 'lv', name: 'Latvian' },
    { code: 'kk', name: 'Kazakh' },
] as const;

export const AVAILABLE_LANGUAGES = AVAILABLE_LANGUAGES_FULL.map(({ code }) => code);

export const AVAILABLE_LANGUAGES_CODE_TO_NAME = Object.fromEntries(
    AVAILABLE_LANGUAGES_FULL.map(({ code, name }) => [code, name])
) as LanguageCodeToName;

export const DEFAULT_LANGUAGE = 'en';

export enum TRANSLATION_STATUSES {
    'IN_PROGRESS' = 'IN_PROGRESS',
    'FAILED' = 'FAILED',
    'CREATED' = 'CREATED',
}

export const BASE_POLL_INTERVAL = 5000;
export const STALE_TIME = 5000;

// TTL for recently-created localization key highlights (24 hours).
export const RECENT_KEYS_TTL_MS = 24 * 60 * 60 * 1000;
